import { jsx } from 'react/jsx-runtime';
import 'luxon';
import { useMemo } from 'react';
import 'styled-components';
import '../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import _ from 'lodash';
import '../../../theme/ThemedComponentWrapper.js';
import 'ethereum-blockies-base64';
import '../../icons/ActivityIcon.js';
import '../../icons/ArrowDownIcon.js';
import '../../icons/ArrowDownRightCircleIcon.js';
import '../../icons/ArrowLeftAlignIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightAlignIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/ArrowSwitchIcon.js';
import '../../icons/ArrowUpIcon.js';
import '../../icons/ArrowUpRightCircleIcon.js';
import '../../icons/ArrowsAngleExpandIcon.js';
import '../../icons/BankIcon.js';
import '../../icons/CheckIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/CrossIcon.js';
import '../../icons/DaiIcon.js';
import '../../icons/DangerIcon.js';
import '../../icons/DownSortIcon.js';
import '../../icons/ExclamationTriangleIcon.js';
import '../../icons/ExpandKpiIcon.js';
import '../../icons/EyeIcon.js';
import '../../icons/EyeSlashIcon.js';
import '../../icons/Grid1x2Icon.js';
import '../../icons/InfoCircleIcon.js';
import '../../icons/ListIcon.js';
import '../../icons/LockIcon.js';
import '../../icons/MediumIcon.js';
import '../../icons/MoonIcon.js';
import '../../icons/PiggyBankIcon.js';
import '../../icons/QuestionMarkCircleIcon.js';
import '../../icons/ShieldIcon.js';
import '../../icons/SunIcon.js';
import '../../icons/UpSortIcon.js';
import '../../icons/XIcon.js';
import '../../icons/InfinityIcon.js';
import '../../icons/ArrowUpRightBoxIcon.js';
import '../../atoms/layout/Stack/Stack.js';
import '../../atoms/Table/components/Pagination/Pagination.js';
import '../../atoms/Table/Table.js';
import '../../atoms/ToggleSwitch.js';
import '@floating-ui/react';
import '../../atoms/Tooltip/components/TooltipContext.js';
import '../../molecules/CurrencyValue/components/Value.js';
import EmptyBox from '../../molecules/EmptyBox.js';
import '../../molecules/KpiCard/KpiCard.js';
import '../../molecules/PercentageValue.js';
import '../../molecules/Tabs/Tabs.js';
import '../../molecules/TrendValue.js';
import '../../pictograms/EthPictogram.js';
import '../../pictograms/EtherScanPictogram.js';
import '../../pictograms/DebankPictogram.js';
import '../../pictograms/ZapperPictogram.js';
import '../../pictograms/DaiPictogram.js';
import '../../molecules/Modal/Modal.js';
import SimpleChart from '../SimpleChart.js';
import '../ChartKpis/ChartKpi.js';
import '../ChartJS.js';
import '../Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../XRay.js';

function LineChart({ data, datasets, config, showValuesInTooltip = false, ...rest }) {
    const mergedConfig = useMemo(() => {
        const defaultConfig = {
            type: 'line',
            options: {
                fill: true,
                elements: {
                    line: {
                        borderWidth: 2
                    }
                }
            }
        };
        return _.merge(defaultConfig, config);
    }, [config]);
    if (datasets) {
        return (jsx(SimpleChart, { data: data, datasets: datasets, config: mergedConfig, showValuesInTooltip: showValuesInTooltip, ...rest }));
    }
    return jsx(EmptyBox, {});
}

export { LineChart as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
